module.exports = __webpack_public_path__ + "static/img/cage_and_tudor_in_japan.86238e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/thumbs/cage_and_tudor_in_japan.jpg
// module id = La2J
// module chunks = 0